export default __webpack_public_path__ + "static/media/hospital-rhea.6de4fd23.png";